import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-12 p-0" }
const _hoisted_4 = { class: "login-card" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group mb-0" }
const _hoisted_8 = { class: "text-end mt-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-4 mb-0 text-center" }

import { ref } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'forgetPasswordPage',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const toaster = createToaster({});
const router = useRouter();

const email = ref<string>("");
const isSubmitting = ref<boolean>(false);

async function requestOTP() {
    if (!email.value) {
        toaster.show("Please enter your email address", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    isSubmitting.value = true;
    try {
        const response = await axios.post(`${baseUrl}api/user/forgot-password-otp`, {
            email: email.value
        });

        toaster.show("If your email is registered, you will receive a password reset OTP.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'check',
            type: 'success',
            duration: 3000
        });

        // Redirect to OTP verification page with email
        router.push({
            name: 'verifyOtp',
            query: { email: email.value }
        });
    } catch (error: any) {
        console.error('Error requesting OTP:', error);
        toaster.show(error.response?.data?.message || "Failed to send OTP. Please try again.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    } finally {
        isSubmitting.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "theme-form",
                onSubmit: _withModifiers(requestOTP, ["prevent"])
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-center" }, "Forgot Password?", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-center" }, "Enter your email to receive a password reset OTP", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "col-form-label" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    class: "form-control",
                    type: "email",
                    placeholder: "Enter your email",
                    required: ""
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit",
                      disabled: isSubmitting.value
                    }, _toDisplayString(isSubmitting.value ? 'Sending...' : 'Send OTP'), 9, _hoisted_9)
                  ])
                ]),
                _createElementVNode("p", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/login"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode(" Back to Login ")
                    ])),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})